import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_e4qxjs0kym: FaireBrandEntity = {
  token: "b_e4qxjs0kym",
  type: "brand",
  name: "amente",
  avatarUrl: "https://cdn.faire.com/fastly/29debc7fb95b7d368ead611c943f2734bbaecafa8db551d7a11fe365bcf9ed39.jpeg",
  bannerUrl: "https://cdn.faire.com/fastly/bd2723003da02f5bfc08f987908acce5c29f623fab304324fb4702a9a0886cf6.jpeg",
  logoUrl: "https://cdn.faire.com/fastly/29debc7fb95b7d368ead611c943f2734bbaecafa8db551d7a11fe365bcf9ed39.jpeg",
  heroImageUrl: "https://cdn.faire.com/fastly/bd2723003da02f5bfc08f987908acce5c29f623fab304324fb4702a9a0886cf6.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 300,
  rating: 4.9,
  reviewCount: 112,
  isTopShop: true,
  isInsider: true,
  description: "Timeless and minimal sustainable fashion.\nCarefully selected premium quality fabrics to create a collection of effortless pieces for the modern woman's wardrobe. \nWe have been continuously focusing on looking at responsible and sustainable ways to conduct ourselves in fashion.\nWe aren't perfect, but we will continue to work hard until our responsibilities are met.\nThe Los Angeles-based house uses sustainable material and way with earth color palette to create.",
  meta: {
    source: "api",
    importedAt: "2026-10-14T17:08:04.251Z",
    importedBy: "entity-db-cli"
  }
};
